import { HarbourDialConfigBlockState } from './types';

const defaultState: HarbourDialConfigBlockState = {
    settings: {
        fontSize: 11,
        runwayAngle: 45,
        showWindDirection: true,
        showWindSpeed: true,
    },
    databilities: [],
};

export default defaultState;
